import ReactDOM from 'react-dom/client';
import { lazy, Suspense } from 'react';
import App from './App';
import { LangProvider } from './contexts/LangProvider';
import { REDESIGN_ENABLED } from './redesign/flag';
// The design-system tokens are the base layer for BOTH apps, not the
// redesign's private file: from Phase 2 the legacy board is styled from
// them too (plan decision 7 — one board, re-skinned in place). Imported at
// the entry so it is first in the cascade and its ownership of a name does
// not depend on which lazy chunk happens to load.
import './styles/tokens.css';
import './styles/colorblind.css';
import './index.css';

// Lazy-load the whole redesign so its screen CSS never enters the legacy
// bundle and its class names cannot collide. The token layer above is the one
// deliberate exception: both apps read it.
const RedesignApp = lazy(() => import('./redesign/RedesignApp'));
// Legacy has no router, so its two document pages are picked here. Lazy for the
// same reason: the texts and their Markdown renderer stay out of the game bundle.
const LegacyLegal = lazy(() => import('./legal/LegacyLegal'));
const LEGAL_PATHS = ['/terms', '/privacy'];

ReactDOM.createRoot(document.getElementById('root')!).render(
  <LangProvider>
    {REDESIGN_ENABLED ? (
      <Suspense fallback={null}><RedesignApp /></Suspense>
    ) : LEGAL_PATHS.includes(window.location.pathname) ? (
      <Suspense fallback={null}><LegacyLegal /></Suspense>
    ) : (
      <App />
    )}
  </LangProvider>
);
